import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-3">
            <i className="ri-notification-3-line mr-1"></i>实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500">平台更新、新片上线与功能动态一览</p>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-3">
            {updateItems.map((item) => (
              <a
                key={item.title}
                href="#updates"
                className="flex items-start gap-4 md:gap-5 group cursor-pointer"
              >
                <div className="relative z-10 flex-shrink-0 mt-1">
                  <span className="block w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background-100 bg-primary-500 ring-2 ring-primary-500/20"></span>
                </div>
                <div className="flex-1 min-w-0 pb-4 border-b border-background-200/30">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span
                      className={`px-2 py-0.5 text-xs rounded-full font-medium flex-shrink-0 ${
                        item.typeColor === 'accent'
                          ? 'bg-accent-500/15 text-accent-400'
                          : item.typeColor === 'primary'
                            ? 'bg-primary-500/15 text-primary-400'
                            : 'bg-secondary-500/15 text-secondary-400'
                      }`}
                    >
                      {item.type}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <p className="text-sm text-foreground-700 group-hover:text-primary-400 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}